export default "__VITE_ASSET__C6i1qnrX__"